const clickIds = [
    { title: "Submit Self-Declaration Form", click_id: "HAE_Submit_SelfDeclarationForm_Clk" },
    { title: "Submit Self Declaration", click_id: "HAE_Submit_SelfDeclaration_Clk" },
];

export function getClickIdByTitle(title) {
    const found = clickIds.find(item => item.title === title);
    return found ? found.click_id : undefined;
}